import React from "react";
import { useColors } from "../contexts/ColorContext";
import FormfacadeEmbed from "@formfacade/embed-react";

function Contact() {
  const { getClasses } = useColors();

  return (
    <section id="contacto" className="py-20 bg-gray-100">
      <div className="container mx-auto px-6">
        <div className="text-center mb-12">
          <h2
            className={`text-3xl font-bold ${getClasses("secondary-text")} mb-4`}
          >
            Contáctenos para su presupuesto gratuito
          </h2>
          <p className="text-gray-600 max-w-2xl mx-auto">
            Estamos aquí para responder a sus preguntas y ayudarle con sus
            necesidades. Póngase en contacto con nosotros y un miembro de
            nuestro equipo se comunicará con usted a la brevedad.
          </p>
        </div>

        <div className="flex flex-col lg:flex-row">
          <div className="lg:w-1/3 mb-10 lg:mb-0">
            <div className="bg-white p-8 rounded-lg shadow-md">
              <h3
                className={`text-xl font-bold ${getClasses("primary-text")} mb-6`}
              >
                Información de Contacto
              </h3>

              <div className="mb-6">
                <h4 className="text-gray-800 font-semibold mb-2">Email</h4>
                <p className="text-gray-600">info@jambops.com</p>
                <p className="text-gray-600">
                  comercial@instalacionestronat.com
                </p>
              </div>

              <div className="mb-6">
                <h4 className="text-gray-800 font-semibold mb-2">
                  Teléfono o WhatsApp
                </h4>
                <p className="text-gray-600">+34 648 71 56 45</p>
                <a
                  href="https://wa.me/34648715645?text=Hola!%20Me%20gustaria%20solicitar%20mas%20informacion%20sobre:%20%20"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="inline-flex items-center mt-2 bg-green-500 hover:bg-green-600 text-white font-medium py-2 px-4 rounded-md transition duration-300"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="18"
                    height="18"
                    fill="currentColor"
                    className="mr-2"
                    viewBox="0 0 16 16"
                  >
                    <path d="M13.601 2.326A7.854 7.854 0 0 0 7.994 0C3.627 0 .068 3.558.064 7.926c0 1.399.366 2.76 1.057 3.965L0 16l4.204-1.102a7.933 7.933 0 0 0 3.79.965h.004c4.368 0 7.926-3.558 7.93-7.93A7.898 7.898 0 0 0 13.6 2.326zM7.994 14.521a6.573 6.573 0 0 1-3.356-.92l-.24-.144-2.494.654.666-2.433-.156-.251a6.56 6.56 0 0 1-1.007-3.505c0-3.626 2.957-6.584 6.591-6.584a6.56 6.56 0 0 1 4.66 1.931 6.557 6.557 0 0 1 1.928 4.66c-.004 3.639-2.961 6.592-6.592 6.592zm3.615-4.934c-.197-.099-1.17-.578-1.353-.646-.182-.065-.315-.099-.445.099-.133.197-.513.646-.627.775-.114.133-.232.148-.43.05-.197-.1-.836-.308-1.592-.985-.59-.525-.985-1.175-1.103-1.372-.114-.198-.011-.304.088-.403.087-.088.197-.232.296-.346.1-.114.133-.198.198-.33.065-.134.034-.248-.015-.347-.05-.099-.445-1.076-.612-1.47-.16-.389-.323-.335-.445-.34-.114-.007-.247-.007-.38-.007a.729.729 0 0 0-.529.247c-.182.198-.691.677-.691 1.654 0 .977.71 1.916.81 2.049.098.133 1.394 2.132 3.383 2.992.47.205.84.326 1.129.418.475.152.904.129 1.246.08.38-.058 1.171-.48 1.338-.943.164-.464.164-.86.114-.943-.049-.084-.182-.133-.38-.232z" />
                  </svg>
                  WhatsApp
                </a>
              </div>

              <div>
                <h4 className="text-gray-800 font-semibold mb-2">
                  Horario de Atención Telefónica
                </h4>
                <p className="text-gray-600">Lunes a Viernes: 9:00 - 18:00</p>
                <p className="text-gray-600">Sábado: 10:00 - 14:00</p>
              </div>
            </div>
          </div>

          <div className="lg:w-2/3 lg:pl-10">
            <FormfacadeEmbed
              formFacadeURL="https://formfacade.com/include/104796305416123703151/form/1FAIpQLSeZn5LyhD0CIzQNiI1cqtikAYODPDfl-aaCZc7vpBpRKzPHDQ/classic.js/?div=ff-compose"
              onSubmitForm={() => console.log("Form submitted")}
            />
          </div>
        </div>
      </div>
    </section>
  );
}

export default Contact;
